import React from 'react';
import { motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SmartImage } from '../common/SmartImage';
import { Drink } from '../../lib/data';
import { useI18n } from '../../lib/i18n';
import { useCart } from '../../lib/cart';
export function DrinkRow({
  drink
}: {
  drink: Drink;
}) {
  const {
    t,
    lang
  } = useI18n();
  const {
    add,
    decrement,
    qtyOf
  } = useCart();
  const qty = qtyOf(drink.id);
  const outOfStock = !drink.inStock;
  const name = lang === 'en' ? drink.name_en : drink.name_am;
  return <div className={`glass-card flex items-center gap-4 p-3 sm:p-4 ${outOfStock ? 'border-[rgba(59,130,246,0.5)] bg-[rgba(30,58,138,0.35)]' : ''}`} data-id="element-116" data-mp="1e9kwku3rplii">
      <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg border border-[rgba(217,217,217,0.15)] bg-white/5" data-id="element-117" data-mp="149ail79wsa2a">
        <SmartImage src={drink.image} alt={name} className={`h-full w-full object-contain p-1 ${outOfStock ? 'opacity-60' : ''}`} data-id="element-118" data-mp="2unku5yf54z2l" />
      </div>

      <div className="min-w-0 flex-1" data-id="element-119" data-mp="27ra7870kdevn">
        <p className={`truncate text-base font-semibold ${outOfStock ? 'text-blue-300' : 'text-white'}`} data-id="element-120" data-mp="27q8ywaaxn6hm">
          {name}
        </p>
        <p className="text-sm text-silver/60" data-id="element-121" data-mp="2hi4vti1a8qk9">
          {drink.volume} · {drink.price} ETB
        </p>
        {outOfStock ? <span className="mt-1 inline-block rounded-full bg-[rgba(59,130,246,0.25)] px-2.5 py-0.5 text-xs font-medium text-blue-300" data-id="element-122" data-mp="2cjafqnup9g3u">
            {t('out_of_stock')}
          </span> : <span className="mt-1 inline-flex items-center gap-1.5 text-xs font-medium text-[#4ADE80]" data-id="element-123" data-mp="1jvo0gic40n15">
            <span className="h-1.5 w-1.5 rounded-full bg-[#4ADE80]" data-id="element-124" data-mp="1ysyjccr30v6w" />
            {t('in_stock')}
          </span>}
      </div>

      <div className="flex-shrink-0" data-id="element-125" data-mp="3a6iu7ywa9owc">
        {outOfStock ? <span className="text-xs font-medium text-blue-300/70" data-id="element-126" data-mp="3a4zdy8amnduk">—</span> : qty === 0 ? <motion.button whileTap={{
        scale: 0.9
      }} type="button" onClick={() => add(drink)} className="inline-flex items-center gap-1.5 rounded-lg bg-neon px-4 py-2 text-sm font-semibold text-white hover:bg-[#ff8524]" aria-label={`${t('add')} ${name}`} data-id="element-127" data-mp="356xtbixjz6gz">
            <PlusIcon className="h-4 w-4" data-id="element-128" data-mp="3r8gaqkzk57jo" />
            {t('add')}
          </motion.button> : <div className="flex items-center gap-2 rounded-lg border border-[rgba(255,113,1,0.4)] p-1" data-id="element-129" data-mp="2tko99etgvk6a">
            <button type="button" onClick={() => decrement(drink.id)} className="flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-[rgba(217,217,217,0.1)]" aria-label={`Decrease ${name}`} data-id="element-130" data-mp="2yig4ahpermep">
              <MinusIcon className="h-4 w-4" data-id="element-131" data-mp="2atwsvtb2atie" />
            </button>
            <span className="w-6 text-center text-base font-semibold text-white" data-id="element-132" data-mp="2arkgrwrzjdd9">
              {qty}
            </span>
            <button type="button" onClick={() => add(drink)} className="flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-[rgba(217,217,217,0.1)]" aria-label={`Increase ${name}`} data-id="element-133" data-mp="wxn3bs05rwna">
              <PlusIcon className="h-4 w-4" data-id="element-134" data-mp="nv473qqvoia0" />
            </button>
          </div>}
      </div>
    </div>;
}